import { checkBeforeEnter } from '@/auth/utils';

export default [
	{
		path: '/areas-responsables',
		name: 'responsible-areas',
		component: () => import('@/views/modules/responsible-areas/responsible-areas-list/ResponsibleAreasList.vue'),
		beforeEnter: (to, from, next) => { checkBeforeEnter(['isSuperAdmin', 'isAdmin'], to, from, next) },
		meta: {
			resource: 'ACL',
			pageTitle: 'Áreas Responsables',
			breadcrumb: [{
				text: 'Asignación de áreas responsables',
				active: true
			}],
			requiresAuth: true
		}
	}
]